import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../actions/productHistoryActions';
import * as api from '../api/productHistory';
import { loadHistory, saveHistory } from 'src/utils/storage/productHistory'
import logger from 'src/utils/logger';
function* getArtemisProductHistory(params) {
  try {
    let data = loadHistory(params.params);
    if (data.length === 0 && window.navigator.onLine) { //localde yok
      const result = yield call(api.getArtemisProductHistory, params.params);
      data = result.data === "" ? [] : result.data;
      saveHistory(params.params, data);
    }
    yield put(actions.productHistorySuccess(data));
  } catch (error) {
    yield put(actions.setError(error));
    logger.error(error);
  }
}

function* watchGetProductHistoryRequest() {
  yield takeEvery(actions.Types.GET_PRODUCT_HISTORY_REQUEST, getArtemisProductHistory);
}

const productHistorySagas = [fork(watchGetProductHistoryRequest)];

export default productHistorySagas;
